'use client'

import React from 'react'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { getDevicePlatform } from '@utils/segmentProperties'
import { CONTACT_US_EVENTS, grievanceCtaEventConfig } from '@configs/contactus.config'
import { ArrowRight } from '@quark/icons'
import styles from './styles.module.scss'

const ComplaintSection = ({ tag, title, cta }) => {
  const handleCtaClick = async (type: string) => {
    await trackEvent(CONTACT_US_EVENTS.GRIEVANCE_CLICKED.eventName, {
      ...CONTACT_US_EVENTS.GRIEVANCE_CLICKED.eventProps,
      platform: getDevicePlatform(),
      type: grievanceCtaEventConfig[type],
    })
  }

  return (
    <div className={styles.complaintBox}>
      <div className={styles.complaintContent}>
        <div className={`${styles.tag} ${styles[`tag--${tag.colorScheme}`]}`}>{tag.text}</div>
        <div className={styles.titleContainer}>
          <div className={styles.title}>{title}</div>
          <div className={styles.ctaContainer}>
            {cta.map((ctaItem, idx) => (
              <a
                href={ctaItem.Link}
                className={styles.cta}
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                onClick={() => handleCtaClick(ctaItem.Title)}
                key={idx}>
                <div className={styles.ctaContent}>
                  {ctaItem.Title}
                </div>
                {ctaItem.Arrow &&
                  <div className={styles.arrowContainer}>
                    <ArrowRight />
                  </div>
                }
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ComplaintSection
